<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout justify-center wrap class="marginTop20px paddingBottom80px">
    <v-flex xs12 sm10 md10 v-if="!hideHeader">
      <v-card flat color="transparent">
        <v-card-title class="headline font-weight-thin bluetext">
          {{ $t('TITLE_SEARCHMASK_CONFIG', { idModule: idModuleName}) }}  <!-- {{balanceName}}-->
        </v-card-title>
      </v-card>
    </v-flex>
    <v-flex xs12 sm10 md10>
      <v-card flat>
        <v-toolbar color="#004884" dark flat height="38px" v-if="!hideHeader">
          <v-toolbar-title class="subheading">{{ 'TITLE_SEARCHMASK_FIELDS' | translate}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-layout justify-center row wrap class="ma-3">
          <v-flex xs11 sm6>
            <v-card flat>
              <v-text-field
                v-model="search"
                append-icon="search"
                :label="searchlabel"
                clearable
                solo
                single-line
                hide-details
              ></v-text-field>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout justify-end row wrap class="ma-3">
          <v-flex xs12 sm3 class="ma-0"  v-if="!hideHeader">
            <v-btn :loading="isLoading" dark color="blue" class="text-none" block @click="addItems()">{{ 'BUTT_SAVE' | translate}} &nbsp; <v-icon v-if="showDone">done</v-icon> </v-btn>
          </v-flex>
        </v-layout>
        <v-tabs
          color="white"
          light
          name="sbTabPanel"
          v-if="pgresults != null && pgresults.length > 0"
          v-model="tabsmc"
          ref="myTab"
          slider-color="#8ACAC1"
          class="activetab"
        >
          <v-tab name="tabNM" href="#tabNM">{{ 'TAB_FILTER_CONFIG_NM' | translate}}</v-tab>
          <v-tab name="tabKZ" href="#tabKZ" v-if="showKZ">{{ 'TAB_FILTER_CONFIG_KZ' | translate}}</v-tab>
          <v-tab name="tabSP" href="#tabSP" v-if="showSP">{{ 'TAB_FILTER_CONFIG_SP' | translate}}</v-tab>
          <v-tab-item active value="tabNM" name="tabNM">
            <v-container>
              <v-data-table
                v-model="selected"
                :headers="headersNM"
                :items="filteredItemsNM"
                :pagination.sync="pagination"
                hide-actions
                class="elevation-1 ma-2"
                :search="search"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th>
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click.stop="toggleAll(filteredItemsNM)"
                      ></v-checkbox>
                    </th>
                    <td
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['text-xs-left column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr :active="props.selected">
                    <td style="width: 40px" @click="props.selected = !props.selected">
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <!--<td class="text-xs-left">{{ props.item.id }}</td>-->
                    <td class="text-xs-left">{{ props.item.name }}</td>
                    <td class="text-xs-left">
                      <!--
                      <v-select
                        v-if="props.item.id === 'bankscore'"
                        solo
                        item-text="name"
                        item-value="id"
                        class="mt-2 pb-0 mb-0"
                        v-model="props.item.dimension"
                        :items="itemscurrencydimension"
                        :label="label_select_currency_dimension"
                      ></v-select>-->
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item value="tabKZ" name="tabKZ" v-if="showKZ">
            <v-container>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItemsKZ"
                :pagination.sync="pagination"
                hide-actions
                class="elevation-1 ma-2"
                :search="search"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th>
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click.stop="toggleAll(filteredItemsKZ)"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['text-xs-left column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr :active="props.selected">
                    <td style="width: 40px" @click="props.selected = !props.selected">
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <!--<td class="text-xs-left">{{ props.item.id }}</td>-->
                    <td class="text-xs-left" style="width: 60%">{{ props.item.name }}</td>
                    <td class="text-xs-left">
                      <v-select
                        v-if="(props.item.unit === 2)"
                        solo
                        item-text="name"
                        item-value="id"
                        class="mt-2 pb-0 mb-0"
                        v-model="props.item.dimension"
                        :items="itemscurrencydimension"
                        :label="label_select_currency_dimension"
                      ></v-select>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item value="tabSP" name="tabSP" v-if="showSP">
            <v-container>
              <v-data-table
                v-model="selected"
                :headers="headers"
                :pagination.sync="pagination"
                :items="filteredItemsSP"
                hide-actions
                class="elevation-1 ma-2"
                :search="search"
              >
                <template v-slot:headers="props">
                  <tr>
                    <th>
                      <v-checkbox
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click.stop="toggleAll(filteredItemsSP)"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['text-xs-left column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr :active="props.selected">
                    <td style="width: 40px" @click="props.selected = !props.selected">
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <!--<td class="text-xs-left">{{ props.item.id }}</td>-->
                    <td class="text-xs-left" style="width: 60%">{{ props.item.name }}</td>
                    <td class="text-xs-left">
                      <v-select
                        v-if="props.item.unit === 2"
                        solo
                        item-text="name"
                        item-value="id"
                        class="mt-2 pb-0 mb-0"
                        v-model="props.item.dimension"
                        :items="itemscurrencydimension"
                        :label="label_select_currency_dimension"
                      ></v-select>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 class="ma-3"  v-if="!hideHeader">
      <v-btn :loading="isLoading" dark color="blue" class="text-none" block @click="addItems()">{{ 'BUTT_SAVE' | translate}} &nbsp; <v-icon v-if="showDone">done</v-icon> </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue'
import FixedTableIE from './../tables/EasyTableIE'
var _ = require('lodash')
export default {
  name: 'TableSearchMaskColumns',
  components: {FixedTableIE},
  methods: {
    open: function (tableData) {
      this.pgresults = tableData
    },
    close: function () {
      if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
        this.$refs.sdTable.doDestroyTable()
      }
    },
    onGetData: function(data) {
      this.open(data)
      Vue.prototype.$api.getAvailableSearchFieldColumnsForUser(this.defUserId, this.clientNr, this.target, this.onGetUserSelected)
      if (this.filteredItemsKZ.length < 1) {
        this.showKZ = false
      }
      if (this.filteredItemsSP.length < 1) {
        this.showSP = false
      }
      _.forEach(this.pgresults, function (item) {
        item.dimension = '1'
      })
    },
    onSetData: function(data) {
      this.showDone = true
      Vue.prototype.$api.debug('onSetData', data)
      this.$emit('onFilterFieldsSaved', data)
    },
    addItems: function() {
      this.showDone = false
      Vue.prototype.$api.debug('addItems', this.selected)
      /*
      var index = 0
      _.forEach(this.selected, function (value) {
        value['orderNr'] = index
        index++
      })
      */
      Vue.prototype.$api.setAvailableFilterListColumns(this.defUserId, this.clientNr, this.target, this.selected, this.onSetData)
    },
    onGetUserSelected: function(data) {
      var cmp = this
      Vue.prototype.$api.debug('onGetUserSelected', data, cmp.userFilters, cmp.selected)
      cmp.selected = []
      this.userFilters = data.array
      _.forEach(this.pgresults, function (item) {
        var index = _.findIndex(cmp.userFilters, function(o) {
          var hit = (item.type === o.type) && (item.id === o.id)
          return hit
        })

        if (index > -1) {
          let userFilter = cmp.userFilters[index]
          item.dimension = userFilter.dimension
          cmp.selected.push(item)
        }
      })
      this.isLoading = false
      Vue.prototype.$api.debug('onGetUserSelected', data, cmp.userFilters, cmp.selected)
      Vue.prototype.$api.hideIdle()
    },
    toggleAll: function (toAppend) {
      if (toAppend) {
        let hasEntriesSelected = this.selected.filter( function( el ) {
          return toAppend.indexOf( el ) > -1;
        });
        hasEntriesSelected = hasEntriesSelected && hasEntriesSelected.length > 0
        if (hasEntriesSelected) {
          this.selected = this.selected.filter( function( el ) {
            return toAppend.indexOf( el ) < 0;
          });
        } else {
          this.selected = this.selected.filter( function( el ) {
            return toAppend.indexOf( el ) < 0;
          });
          this.selected = this.selected.concat(toAppend)
        }
      } else {
        if (this.selected.length) this.selected = []
        else this.selected = this.pgresults.slice()
      }
    },
    toggleAll2: function() {
      if (this.selected.length) this.selected = []
      else this.selected = this.pgresults.slice()
    },
    changeSort: function(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    initialLoad: function (balanceName, hideHeader) {
      this.hideHeader = hideHeader
      this.idModule = this.$route.params.idModule
      this.balanceName = balanceName
      this.idModuleName = Vue.i18n.translate(this.idModule.toUpperCase() + '_TITLE')
      this.target = this.idModule + this.balanceName
      this.defUserId = this.$route.params.defUserId

      Vue.prototype.$api.showIdle()
      this.itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()
      if (this.defUserId === undefined) {
        this.defUserId = -1
      }
      if (this.defUserId && this.idModule) {
        Vue.prototype.$api.getAvailableSearchFieldColumns(this.defUserId,this.clientNr,this.idModule, this.balanceName, this.onGetData)
      }
    }
  },
  computed: {
    filteredItemsKZ() {
      if (!this.pgresults) return []
      return this.pgresults.filter((item) => {
        return item.type === 'kz'
      })
    },
    filteredItemsNM() {
      if (!this.pgresults) return []
      return this.pgresults.filter((item) => {
        return item.type === 'nm'
      })
    },
    filteredItemsSP() {
      if (!this.pgresults) return []
      return this.pgresults.filter((item) => {
        return item.type === 'sp'
      })
    }
  },
  data() {
    return {
      clientNr: 463,
      balanceName: '',
      idModuleName: '',
      isLoading: true,
      tabsmc: '',
      showKZ: true,
      itemscurrencydimension: [],
      label_select_currency_dimension: Vue.i18n.translate('CURRENCY_DIMENSION'),
      showSP: true,
      searchlabel: Vue.i18n.translate('LABLE_SEARCH_SEARCHMASK'),
      tableNotComplete: false,
      hideHeader: false,
      showDone: false,

      selected: [],
      pagination: {
        rowsPerPage: -1,
        sortBy: 'name'
      },
      headersNM: [
        /*
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
         */
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_NAME'),
          align: 'left',
          sortable: true,
          width: 28,
          value: 'name'
        }
        /*
        ,
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_WIDTH'),
          align: 'left',
          sortable: false,
          value: 'width'
        }
        */
      ],
      headers: [
        /*
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        */
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_NAME'),
          align: 'left',
          width: 28,
          sortable: true,
          value: 'name'
        },
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_DIMENSION'),
          align: 'left',
          width: 100,
          value: 'dimension'
        }

        /*
        ,
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_TYPE'),
          align: 'left',
          sortable: true,
          value: 'type'
        },
        {
          text: Vue.i18n.translate('HEADER_HIT_LIST_WIDTH'),
          align: 'left',
          sortable: false,
          value: 'width'
        }
         */
      ],
      pgresults: [],
      target: '',
      currentCurrency: '1',
      bankAnchor: null,
      search: '',
      idModule: '',
      defUserId: -1,
      idModuleItem: '',
      'tableConfig': {
        selection: false,
        header: {
          columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1'
        },
        rows: {
          rowClass: 'rowEIE'
        }
      }
    }
  },
  mounted () {
    this.clientNr = this.$route.params.clientNr
    this.defUserId = this.$route.params.defUserId
    this.isLoading = true
    this.initialLoad(this.$route.params.balanceName, false)

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/TableSearchMaskColumns.vue